export const BOOK_GHE = "BOOK_GHE";
export const DELETE_GHE = "DELETE_GHE";